export default __webpack_public_path__ + "static/animates-87422c4d86b9a85d69728f01b988e0c6.svg";